<template>
    <div class="flex-center stepper">
      <div @click="subtract" :style="{background}"><van-icon name="minus" size="18" /></div>
      <input type="number" :style="{ background }" max="240" min="0" oninput="if(value>240)value=240" :value="value" @input="handleInput" />
      <div @click="add" :style="{ background }"><van-icon name="plus" size="18" /></div>
    </div>
</template>

<script>
export default {
  props: {
    value: {},
    background: {
      type: String,
      default: '#fff'
    }
  },
  data() {
    return {
      modelValue: this.value
    };
  },
  methods: {
    subtract() {
      if(this.value <=0) return
      this.$emit('input', this.value * 1 - 1)
    },
    add() {
      this.$emit('input', this.value * 1 + 1)
    },
    handleInput(event) {
      this.$emit('input', event.target.value * 1)
    }
  },
};
</script>

<style scoped lang="scss">
.stepper{
  img{
    width: 13px;
    height: 13px;
  }
  input{
    border: 1px solid #E5E5E5;
    width: 55px;
    height: 36px;
    border-radius: 3px;
    background: #FFFFFF;
    text-align: center;
    margin: 0 2px;
    font-size: 13px;
    color: #333333;
  }
  div{
    color: #3D3D3D;
    background-color: #fff;
    width: 24px;
    height: 26px;
    border-radius: 2px 0px 0px 2px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
